import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { TIPOS_OCUPANTE } from '../api/tenencias';

const REDIRECT_KEY = 'calbucura.postLoginRedirect';

// Sprint 18 P2-B3: onboarding bloqueante. El wizard lo hace el titular
// OCUPANTE (no el propietario_no_residente, que no onboarda el hogar
// arrendado).
const RUTA_ONBOARDING = '/vecino/onboarding';

interface ProtectedRouteProps {
  requireRole?: string | string[];
}

export function ProtectedRoute({ requireRole }: ProtectedRouteProps) {
  const { status, me } = useAuth();
  const location = useLocation();

  if (status === 'loading') {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p className="text-gray-500">Cargando…</p>
      </div>
    );
  }

  if (status !== 'authenticated' || !me) {
    sessionStorage.setItem(REDIRECT_KEY, location.pathname + location.search);
    return <Navigate to="/login" replace />;
  }

  // Sprint 13 S13-01: gate de dominio. El portal del barrio aloja
  // exclusivamente cuentas operativas. La cuenta institucional
  // (tipo_cuenta='super_admin') opera en sa.calbucura.cl y no debe
  // entrar al portal. Doctrina:
  // docs/dev/doctrina-portal-vs-superadmin.md §2.3.
  if (me.usuario.tipo_cuenta !== 'operativa') {
    return <Navigate to="/sin-permiso" replace />;
  }

  if (requireRole) {
    const required = Array.isArray(requireRole) ? requireRole : [requireRole];
    const tieneAlgunRol = required.some((rol) => me.roles_vigentes.includes(rol));
    if (!tieneAlgunRol) {
      return <Navigate to="/sin-permiso" replace />;
    }
  }

  // Sprint 18 P2-B3: onboarding bloqueante. Si el vecino tiene una tenencia
  // ocupante con el wizard sin completar, se le fuerza al wizard antes de
  // operar el portal (excepto si ya está en él, para no hacer loop).
  const onboardingPendiente = me.tenencias_activas.some(
    (t) => TIPOS_OCUPANTE.includes(t.tipo) && t.wizard_completado === false,
  );
  if (onboardingPendiente && location.pathname !== RUTA_ONBOARDING) {
    return <Navigate to={RUTA_ONBOARDING} replace />;
  }

  return <Outlet />;
}

export { REDIRECT_KEY };
